import { apiInstances } from '../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function confirmOrderNotDelivered({
  id_order,
  ...payload
}) {
  return await post(
    `/clouders/orders/${id_order}/returnToPickupPoint`,
    payload
  );
}
